import { render, staticRenderFns } from "./StepTemperatureIncrease.vue?vue&type=template&id=4c427975&scoped=true&"
import script from "./StepTemperatureIncrease.vue?vue&type=script&lang=js&"
export * from "./StepTemperatureIncrease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c427975",
  null
  
)

export default component.exports